import { render, staticRenderFns } from "./Tesoreria.vue?vue&type=template&id=dda13f3c&"
import script from "./Tesoreria.vue?vue&type=script&lang=js&"
export * from "./Tesoreria.vue?vue&type=script&lang=js&"
import style0 from "./Tesoreria.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports